// extracted by mini-css-extract-plugin
module.exports = {"AppBar":"NavBar_AppBar__1kHui","Toolbar":"NavBar_Toolbar__5VGdM","title":"NavBar_title__3XrU0"};